import { ViewChild, Input, OnInit, Component, Output, EventEmitter } from "@angular/core";
import { OrgListContainerNewComponent } from "./org-list-container.component";
import { OrgSearchNewComponent } from "./org-search.component";
import { MyClientsSavedSearch } from "../../../reports/models/myclients-saved-search";
import { UserAccessGateway } from "../../gateways/user-access-gateway";
import { OrgBrowserView } from "../../../reports/models/org-browser-view";
import { CurrentUser } from "../../models/current-user";
import { NetworkOrganizationDataGateway } from "../../../reports/gatewasys/network-organization-data.gateway";
import { OrganizationDataGateway } from "../../../reports/gatewasys/organization-data.gateway";

@Component({
    selector: 'org-view',
    templateUrl: './org-view-component.html',
    styleUrls: ['./org-view-component.scss']
})


export class OrgViewComponent implements OnInit {
    @Input() labelName: string = 'Choose Organization'
    @Input() currentUser: CurrentUser = {} as CurrentUser
    @Input() orgSelected: OrgBrowserView
    @Input() hideBrowseView: boolean
    @Output() orgAdded: EventEmitter<OrgBrowserView> = new EventEmitter(); 

    @ViewChild('orgListContainer', { static: true })
    private orgListContainer: OrgListContainerNewComponent;

    @ViewChild('orgSearch', { static: true })
    private orgSearch: OrgSearchNewComponent;

    rootOrgId: number
    selectedSearch: MyClientsSavedSearch;

    

    resetSearch: string
    selectedOrgValue: string = '';
    tabToggle: boolean = false
    txtOrgSelected: string
    constructor(private _networkUserAccessGateway: UserAccessGateway, private orgDataGateway: OrganizationDataGateway) {

    }

    ngOnInit() {
        this._networkUserAccessGateway.getCurrentUser()
            .subscribe(user => {
                if (user != null) {
                    this.currentUser = user
                    //this.rootOrgId = parseInt(this.currentUser.orgId, 10)
                    this.showOrgDropDown();
                }
            })
    }

    showOrgDropDown(): void {

        setTimeout(() => {
            if (this.orgListContainer !== undefined && this.orgListContainer !== null) {
                this.orgListContainer.initOrgTree(parseInt(this.currentUser.orgId, 10));
            }
        }, 1000);
    }

    onOrgAdd(org: OrgBrowserView): void {
        this.orgSelected = org
        this.orgAdded.emit(org)
    }

    //addOrg(org: OrgBrowserView): void {
    //    org.includeDownline = true;
    //    this.selectedSearch.selectedOrgs = this.selectedSearch.selectedOrgs.concat([org]);
    //    localStorage.setItem("OrgData", JSON.stringify(this.selectedSearch.selectedOrgs))
    //}

    onSearchResultsChanged(orgs: OrgBrowserView[]): void {
        if (this.selectedSearch === undefined ||
            this.selectedSearch === null ||
            this.selectedSearch.selectedOrgs === undefined ||
            this.selectedSearch.selectedOrgs === null) {
            return;
        }
        this.selectedSearch.selectedOrgs.forEach(o => {
            orgs.forEach(o2 => {
                if (o.orgId === o2.orgId) {
                    o2.selected = true;
                }
            });
        });
    }

    onToggle(): void {
        this.tabToggle = !this.tabToggle
        this.rootOrgId = parseInt(this.currentUser.orgId, 10)
    }

    clearSearch(): void {
        this.orgListContainer.clearSearch()
        this.orgSearch.clearSearch()
        this.orgListContainer.initOrgTree(parseInt(this.currentUser.orgId, 10))
    }
}